var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timeline-wrapper"},[_c('div',{staticClass:"timeline"},_vm._l((_vm.values),function(step,idx){return _c('div',{key:idx,staticClass:"timeline__item",class:{
        active: Number(_vm.currentStep) >= idx + 1,
        current: Number(_vm.currentStep) === idx,
      }},[_c('div',{staticClass:"timeline__point"},[_vm._v(_vm._s(idx + 1))]),_vm._v(" "),_c('div',{staticClass:"timeline__item-content"},[_vm._v(_vm._s(step.content))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4517cf8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/longTermCare/Timeline.vue
// module id = null
// module chunks = 